import {createContext, useContext} from 'react';

/**
 * Как кнопка занимает ширину, когда стоит в колонке одна.
 *
 * В CSS кнопка shadcn — `inline-flex`: она обнимает свою подпись, и «Сохранить» под
 * формой на мониторе — это кнопка шириной со слово, а не полоса на 820pt. В React
 * Native всё — flex-колонка с `alignItems: stretch`, и та же кнопка растягивается на
 * всю ширину родителя. На телефоне это правильно (полоса под большой палец); на
 * широком окне — нет.
 *
 * Правило поэтому задаёт КОНТЕКСТ, а не каждая кнопка: `Page` на широком окне
 * объявляет `hug`, лист снизу и инспектор — `stretch` (там ширина — телефонная), а
 * `block` у самой кнопки перекрывает и то и другое.
 */
export type ButtonLayout = 'hug' | 'stretch';

export const ButtonLayoutContext = createContext<ButtonLayout>('stretch');

export function useButtonLayout(): ButtonLayout {
  return useContext(ButtonLayoutContext);
}
